import { get_token, is_demo_domain as router_is_demo_domain } from '@/router/index.js';
import { show_page_loader, hide_page_loader } from '@/utils/page_loader';
import { prepare_playground_platform_launch } from '@/utils/playground_platform_launch';


export default {
  name: 'HomeView',
  data: () => ({
      workspace_map: {
        file: "File",
        dashboard: "Dashboard",
        analysis: "Analysis",
      },
  }),
  computed: {
    is_demo_domain() {
      return router_is_demo_domain();
    },
  },

  methods: {
    async launch_workspace(tab) {

      const allowed = Object.keys(this.workspace_map);
      if (!allowed.includes(tab)) {
        console.error("Invalid workspace key:", tab);
        return;
      }

      const workspace_type = Reflect.get(this.workspace_map, tab);
      const platform_ready = await prepare_playground_platform_launch('proba', this.$notyf, this.$router);
      if (!platform_ready) {
        return;
      }

      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/create_workspace/`;
      const is_Demo = this.is_demo_domain;
      const token = get_token();

      if (!is_Demo && !token) {
        return;
      }

      show_page_loader(`Launching ${workspace_type}...`);

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { "Authorization": `Token ${token}` } : {}),
            'X-Page-URL': window.location.href,
          },
          body: JSON.stringify({ workspace: workspace_type }),
        });

        const data = await response.json();

        if (response.ok) {
          window.location = data.redirect_url;
        } else {
          this.$notyf.error(data?.message || "Service currently unavailable.");
          hide_page_loader();
        }
      } catch (error) {
        this.$notyf.error(`Error: ${String(error)}`);
        hide_page_loader();
      }
    },
  }
}
